import Comments from '@tine/tiff/dist/templates/comments';

export const Component = Comments;
export default { Component };
